/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerDeletionResponseOutputCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerDeletionResponseOutputDeletedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const CustomerDeletionResponseOutput = zod.object({
  customerId: zod.uuid().regex(customerDeletionResponseOutputCustomerIdRegExp),
  deletedAt: zod.iso
    .datetime({ offset: true })
    .regex(customerDeletionResponseOutputDeletedAtRegExp),
});

export type CustomerDeletionResponseOutput = zod.input<typeof CustomerDeletionResponseOutput>;
export type CustomerDeletionResponseOutputOutput = zod.output<
  typeof CustomerDeletionResponseOutput
>;
